module.exports = __webpack_public_path__ + "assets/img/00160.a17f825b.png";